import { usePermissionsValidator } from '@client/context/hooks';

export const useCheckPermissions = (requiredPermissions: string[]): boolean => {
  const permissionsValidator = usePermissionsValidator();

  return permissionsValidator(requiredPermissions);
};
